import Breadcrumb from "components/Common/Breadcrumb";
import Spinner from "components/spinner";
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { MetaTags } from "react-meta-tags";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import moment from "moment";
import { getAllAppExceptions } from "services/appExceptions.service";
import ExceptionsView from "./View";
import UpdateExceptionStatus from "./UpdateExceptionStatus";
import BreadcrumbSub from "components/Common/BreadcrumbSub";

const AppExceptionsList = () => {
  const { SearchBar } = Search;
  const [exceptionsList, setexceptionsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [updateModal, setUpdatemodal] = useState(false);
  const [activedata, setActivedata] = useState();
  const [pageRange, setPageRange] = useState([1, 5]);
  const [currentPage1, setCurrentPage1] = useState(1);
  const [count, setTotalCount] = useState();
  const itemsPerPage = 10;
  const totalPages = Math.ceil(count / itemsPerPage);
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  useEffect(() => {
    getAppExceptions("app", currentPage1);
  }, [currentPage1]);

  const getAppExceptions = () => {
    setLoading(true);
    getAllAppExceptions("app", currentPage1)
      .then(res => {
        const sortedExceptionsList = res?.data?.sort((a, b) => {
          return new Date(b?.createdAt) - new Date(a?.createdAt);
        });
        setexceptionsList(sortedExceptionsList || []);
        setTotalCount(res?.meta?.count);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
  };
  const toggle = () => {
    setModal(!modal);
  };
  const UpdateToggle = () => {
    setUpdatemodal(!updateModal);
  };
  const handleActiveOrder = data => {
    setActivedata(data);
  };
  const handlePreviousSet = () => {
    const newStart = Math.max(pageRange[0] - 5, 1);
    const newEnd = Math.min(newStart + 4, totalPages);
    setPageRange([newStart, newEnd]);
  };

  const handleNextSet = () => {
    const newEnd = Math.min(pageRange[1] + 5, totalPages);
    const newStart = newEnd - 4;
    setPageRange([newStart, newEnd]);
  };

  const handlePageChange = page => {
    if (currentPage1 !== page) {
      setCurrentPage1(page);
    }
  };
  // Table Data
  const customer = () => [
    {
      dataField: "type",
      text: "Type",
    },
    {
      dataField: "platform",
      text: "Platform",
    },
    {
      dataField: "loggedInAs",
      text: "Logged In As",
    },
    {
      dataField: "page",
      text: "Page",
    },
    {
      dataField: "userId",
      text: "User",
      formatter: (cell, row) => {
        // console.log(row, "row");
        return (
          <div className="">
            <div>
              {row?.loggedInAs === "User" ? (
                <>
                  {row?.userId?.firstname} {row?.userId?.lastname}
                </>
              ) : row?.loggedInAs === "Stylist" ? (
                <>
                  {row?.stylistId?.legalname} {row?.stylistId?.shortname}
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        );
      },
    },
    {
      dataField: "priority",
      text: "Priority",
      formatter: (cellContent, row) => {
        if (row?.priority === "Low") {
          return <div className=" text-secondary fw-bold">Low</div>;
        } else if (row?.priority === "Medium") {
          return (
            <>
              <div className="fw-bold text-warning">Medium</div>
            </>
          );
        } else if (row?.priority === "Critical") {
          return (
            <>
              <div className="fw-bold text-danger">Critical</div>
            </>
          );
        } else if (row?.priority === "danger") {
          return (
            <>
              <div className="fw-bold text-danger">Hight</div>
            </>
          );
        }
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cellContent, row) => {
        if (row?.status === "Pending") {
          return (
            <div className="d-flex align-items-center text-danger">
              <i className="bx bxs-circle me-1 text-danger"></i>
              Pending
            </div>
          );
        } else if (row?.status === "Resolved") {
          return (
            <>
              <div className="d-flex align-items-center">
                <i className="bx bxs-circle me-1 text-success"></i>
                Resolved
              </div>
            </>
          );
        }
      },
    },
    {
      dataField: "createdAt",
      text: "createdAt",
      formatter: (cell, row) => (
        <>{moment(row?.createdAt).format("DD-MMM-YYYY @ hh:mm a")}</>
      ),
    },
    {
      dataField: "updatedAt",
      text: "updatedAt",
      formatter: (cell, row) => (
        <>{moment(row?.updatedAt).format("DD-MMM-YYYY @ hh:mm a")}</>
      ),
    },
    {
      dataField: "",
      text: "View",
      formatter: (cellContent, row) => {
        const badgeColor = "font-size-12 px-2 py-1 badge-soft-";
        return (
          <div className="d-flex gap-3">
            <Badge
              className={badgeColor + "info"}
              color={"bg-secondary"}
              pill
              onClick={() => {
                handleActiveOrder(row);
                // toggle();
                setModal(!modal);
              }}
              role="button"
            >
              <i className="mdi mdi-eye " id="viewtooltip" />
            </Badge>
            {/* <Badge
              className={badgeColor + "success"}
              color={"bg-secondary"}
              pill
              onClick={() => {
                handleActiveOrder(row);
                UpdateToggle();
              }}
              role="button"
            >
              <i className="mdi mdi-pencil " id="editTooltip" />
            </Badge> */}
          </div>
        );
      },
    },
  ];

  const pageOptions = {
    sizePerPage: 5,
    totalSize: exceptionsList?.length, // replace later with size(customers),
    custom: true,
  };
  return (
    <>
      <React.Fragment>
        <Spinner loading={loading} />
        <div className="page-content">
          <MetaTags>
            <title></title>
          </MetaTags>
          <Container fluid>
            <Breadcrumb
              title="Exceptions"
              breadcrumbItem="Mobile Exceptions List"
            />
            <BreadcrumbSub
              subtile="Mobile Exceptions List"
              SubBreadcrumbItem="Exceptions"
            />

            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    {/* <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="exceptionsList"
                      columns={customer()}
                      data={exceptionsList}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="exceptionsList"
                          data={exceptionsList}
                          columns={customer()}
                          bootstrap4
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap">
                                <div className="d-flex align-items-center">
                                  <div className="search-box d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      keyField="exceptionsList"
                                      responsive
                                      bordered={false}
                                      striped={false}
                                      classes={
                                        "table align-middle table-nowrap table-check"
                                      }
                                      headerWrapperClasses={"table-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                    {exceptionsList?.length == 0 && (
                      <p className="text-center"> No Data Found</p>
                    )} */}
                    <div>
                      <ToolkitProvider
                        keyField="exceptionsList"
                        data={exceptionsList}
                        columns={customer()}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap">
                              <div className="d-flex align-items-center">
                                <div className="search-box d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="exceptionsList"
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    classes={
                                      "table align-middle table-nowrap table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    // {...paginationTableProps}
                                    defaultSorted={exceptionsList}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    </div>
                    {exceptionsList && exceptionsList?.length == 0 && (
                      <p className="text-center my-3"> No Data Found</p>
                    )}
                    {exceptionsList && exceptionsList?.length ? (
                      <>
                        <div className="">
                          <Pagination
                            aria-label="Page navigation example"
                            className="pagination pagination-rounded justify-content-end"
                          >
                            <PaginationItem disabled={pageRange[0] === 1}>
                              <PaginationLink
                                previous
                                href="#"
                                onClick={e => {
                                  e.preventDefault();
                                  handlePreviousSet();
                                }}
                              />
                            </PaginationItem>
                            {pages
                              ?.slice(pageRange[0] - 1, pageRange[1])
                              .map(page => (
                                <PaginationItem
                                  active={currentPage1 === page}
                                  key={page}
                                >
                                  <PaginationLink
                                    onClick={e => {
                                      e.preventDefault();
                                      handlePageChange(page);
                                    }}
                                    // href="#"
                                  >
                                    {page}
                                  </PaginationLink>
                                </PaginationItem>
                              ))}
                            <PaginationItem
                              disabled={pageRange[1] >= totalPages}
                            >
                              <PaginationLink
                                next
                                href="#"
                                onClick={e => {
                                  e.preventDefault();
                                  handleNextSet();
                                }}
                              />
                            </PaginationItem>
                          </Pagination>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
      <ExceptionsView
        toggle={toggle}
        modal={modal}
        activeObj={activedata}
        reload={getAppExceptions}
        setModal={setModal}
      />
      {/* <UpdateExceptionStatus
        toggle={UpdateToggle}
        modal={updateModal}
        activeObj={activedata}
        reload={getAllAppExceptions}
      /> */}
    </>
  );
};

export default AppExceptionsList;
